import React from 'react';

const BsContainer = (props) => (
	<div className={[props.fluid ? 'container-fluid' : 'container', props.class].join(' ')} style={props.style}>
		{props.children}
	</div>
);

export default BsContainer;
